import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {moduloAutoconsumo} from "../../diccionarios/autoconsumoModulo";
import {MantenedorSolicitudPedidoVentaService} from "../../services/mantenedor-solicitud-pedido-venta.service";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import {Client} from "../../../portfolio/interfaces/client.interface";
import {Material} from "../../../portfolio/interfaces/material.interface";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-mantenedor-solicitud-pedido-venta',
  templateUrl: './mantenedor-solicitud-pedido-venta.component.html',
  styleUrls: ['./mantenedor-solicitud-pedido-venta.component.css']
})
export class MantenedorSolicitudPedidoVentaComponent implements OnInit, OnDestroy {
  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  formularioFiltro: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  cmbOficinaVenta: any[];
  cmbTipoImputacion: any[];

  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  solicitudData: any;
  subscription1$: Subscription;
  subscription2$: Subscription;
  subscription3$: Subscription;
  subscription4$: Subscription;
  subscription5$: Subscription;

  constructor(
    private fb: FormBuilder,
    private _mantenedorSolicitudPedidoVentaService: MantenedorSolicitudPedidoVentaService,
    private _datosMaestrosService: DatosMaestrosService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloAutoconsumo;
  }

  ngOnDestroy(): void {
    this.subscription1$ && this.subscription1$.unsubscribe();
    this.subscription2$ && this.subscription2$.unsubscribe();
    this.subscription3$ && this.subscription3$.unsubscribe();
    this.subscription4$ && this.subscription4$.unsubscribe();
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloAutoconsumo.button.buttonsNombre;
    this.DAT_TITULOS = moduloAutoconsumo.titulos.mantenedorSolicitudPedidoVenta;
    this.DAT_BTNCSS = moduloAutoconsumo.button.buttonsCss;
    this.DAT_MSG = moduloAutoconsumo.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.cmbTipoImputacion = this.diccionarioModulo.tipoImputacionArray;
    this.formulario = this.fb.group({});
    this.formularioFiltro = this.fb.group({
      idOficinaVenta: [''],
    });
    this.solicitudData = {
      accion: '',
      idPedido: null,
      detallePosicion: '',
      imputacionArray: [],
      lineaDetalleArray: []
    };
    this.girdComponent();
    this.getFormInfo();
    this.getAllPedidoCabecera();

    this.subscription1$ = this._mantenedorSolicitudPedidoVentaService.solicitudVentaListener().subscribe(data => {
      //console.log('lineaDetalleListener', data);
      if (data.action === 'nuevo') {
        //console.log(data);
        this.subscription4$ = this._mantenedorSolicitudPedidoVentaService.guardarSolicitudCompleta(data.result).subscribe(response => {
          //console.log(response);
          this.getAllPedidoCabecera();
        }, error => {

        });
      } else if (data.action === 'editar') {
        this.subscription5$ = this._mantenedorSolicitudPedidoVentaService.actualizarSolicitudCompleta(data.result).subscribe(response => {
          //console.log(response);
          this.getAllPedidoCabecera();
        }, error => {

        });
      }
      this.mostrarGridLista = true;
    });
  }


  getFormInfo() {
    this.loading = true;
    this.subscription2$ = this._datosMaestrosService.getAllOficinasVentas().subscribe((res: any) => {
      res.map(oficinaVenta => {
        oficinaVenta.id = oficinaVenta.idOficinaVenta;
        oficinaVenta.descripcion = oficinaVenta.idOficinaVenta + ' | ' + oficinaVenta.dscaOficinaVenta;
      });

      this.cmbOficinaVenta = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbOficinaVenta = [];
      this._util.mensajeErroToast('Problemas al intentar cargar las Oficinas de Ventas.', 3000);
    });
  }


  nuevo() {
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.solicitudData.accion = 'nuevo';
    this.formulario.reset();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllPedidoCabecera() {
    this.formularioFiltro.reset();
    this.loading = true;
    this.subscription3$ = this._mantenedorSolicitudPedidoVentaService.getAllSolicitudPedidoVenta().subscribe((res: any) => {
      res.forEach((solicitudPedido: any) => {
        if (solicitudPedido && solicitudPedido.lsPedidoDetalle && solicitudPedido.lsPedidoDetalle.length > 0) {
          solicitudPedido.lsPedidoDetalle.forEach(lineaDetalle => {
            if (lineaDetalle && lineaDetalle.lsPedidoImputacion && lineaDetalle.lsPedidoImputacion.length > 0) {
              lineaDetalle.lsPedidoImputacion = lineaDetalle.lsPedidoImputacion.map(imputacion => {
                imputacion.tipoImputacionDescripcion = this.cmbTipoImputacion.find(dataCombo => dataCombo.id === imputacion.tipoImputacion).descripcion
                return imputacion;
              });
            }
          });
        }
      });
      console.log(res);
      this.rowData = res.sort((b, a) => a.idPedido - (b.idPedido));
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
      this._util.mensajeErroToast('Problemas al intentar cargar las solicitudes de Pedidos de Ventas.', 3000);
    });
  }

  getSolicitudByOficinaVenta() {
    this.rowData = [];
    this.loading = true;
    this.subscription3$ = this._mantenedorSolicitudPedidoVentaService.getSolicitudByOficinaVenta(this.formularioFiltro.value).subscribe((res: any) => {
      res.forEach((solicitudPedido: any) => {
        if (solicitudPedido && solicitudPedido.lsPedidoDetalle && solicitudPedido.lsPedidoDetalle.length > 0) {
          solicitudPedido.lsPedidoDetalle.forEach(lineaDetalle => {
            if (lineaDetalle && lineaDetalle.lsPedidoImputacion && lineaDetalle.lsPedidoImputacion.length > 0) {
              lineaDetalle.lsPedidoImputacion = lineaDetalle.lsPedidoImputacion.map(imputacion => {
                imputacion.tipoImputacionDescripcion = this.cmbTipoImputacion.find(dataCombo => dataCombo.id === imputacion.tipoImputacion).descripcion
                return imputacion;
              });
            }
          });
        }
      });
      this.rowData = res.sort((b, a) => a.idPedido - (b.idPedido));
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
      this._util.mensajeErroToast('Problemas al intentar cargar las solicitudes de Pedidos de Ventas.', 3000);
    });
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ID PEDIDO',
        field: 'idPedido',
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'FECHA',
        field: 'fechaPedido',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'CLIENTE',
        field: 'idCliente',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'NOMBRE CLIENTE',
        field: 'nombreCliente1',
        sortable: true,
        filter: true,
        width: 245
      },
      {
        headerName: 'CLASE PEDIDO',
        field: 'idClasePedido',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'MOTIVO PEDIDO',
        field: 'idMotivoPedido',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'ORDEN VENTA',
        field: 'ordenVenta',
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'GERENCIA',
        field: 'codGerencia',
        sortable: true,
        filter: true,
        width: 130
      },
      {
        headerName: 'ESTADO',
        field: 'estado',
        sortable: true,
        filter: true,
        width: 130
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 140,
        cellRendererParams: {
          onClick: this.editarSolicitudVenta.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 140,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarSolicitudVenta({rowData}) {
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.solicitudData.accion = 'editar';
    this.solicitudData.data = rowData;
  }


  eliminar({rowData}) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._mantenedorSolicitudPedidoVentaService.borrarSolicitudPedidoVenta(rowData),
      }
    ).then((res: any) => {
      //this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
      this.getAllPedidoCabecera();
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarSolicitud();
      } else {
        this.guardarSolicitud();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  actualizarSolicitud() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._mantenedorSolicitudPedidoVentaService.actualizarSolicitud(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.regresar();
    });
  }


  guardarSolicitud() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._mantenedorSolicitudPedidoVentaService.guardarSolicitudCompleta(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.regresar();
    });
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  clienteSelected(cliente: Client) {
    //console.log(cliente);
    if (cliente) {
      this._mantenedorSolicitudPedidoVentaService.clienteSelectedEvent(cliente);
    }
  }

  materialSelected(material: Material) {
    //console.log(material);
    if (material) {
      this._mantenedorSolicitudPedidoVentaService.materialSelectedEvent(material);
    }
  }

  changeOficinaVenta() {
    if (this.formularioFiltro && this.formularioFiltro.get('idOficinaVenta') && this.formularioFiltro.get('idOficinaVenta').value && this.formularioFiltro.get('idOficinaVenta').value != '') {
      this.getSolicitudByOficinaVenta();
    }
  }

}
